import { Component, input } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslatedText, Media, TimePeriod } from '../../core/models/';
import { TranslocoLocaleService } from '@jsverse/transloco-locale';
import { TranslocoPipe } from '@jsverse/transloco';

// TODO: needs to open on restaurants page (delivery and pickup) and marche page & remove from main

@Component({
    selector: 'app-service-pause',
    standalone: true,
    imports: [TranslocoPipe],
    templateUrl: './service-pause.component.html',
    styleUrls: ['./service-pause.component.css'],
})
export class ServicePauseComponent {
    readonly header = input<string>(undefined);
    readonly text = input<string>(undefined);
    readonly cancelButtonText = input<string>(null);
    readonly submitButtonText = input<string>(undefined);

    readonly headerParams = input<any>({});
    readonly textParams = input<any>({});
    readonly cancelButtonTextParams = input<any>({});
    readonly submitButtonTextParams = input<any>({});

    // data: {
    //     title: TranslatedText,
    //     image: Media,
    //     description: TranslatedText,
    //     interval: TimePeriod
    // }

    data = {
        title: 'Holiday Schedule',
        image: '../../../assets/images/landing/hero/landing-hero-8.jpg',
        // image: "",
        description:
            'As many of our restaurant and driver members are currently away for the holiday period, we will be operating with a reduced schedule until Jan 3rd. We will be open from 5pm - 10pm from Sunday to Wednesday, and with our regular hours of 10:30am - 10pm from Thursday to Saturday.',
        // interval: "Deliveries will restart on Jan 23rd, 2024 at 4:00pm.",
        interval: {
            start: '2024-01-11T16:00:00',
            end: '2024-01-31T16:00:00',
            active: true,
        },
    };

    //  if service resumes same day: "Deliveries will restart at 4:00pm"
    //  else if different day: "Deliveries will restart on Jan 23rd, 2024 at 4:00pm"

    // make this an object?
    servicePauseEnd: Date = new Date(this.data.interval.end);
    currentDate: Date = new Date();

    // TODO: handle en-CA and fr-CA
    // activeLang: string = this.translate();

    locale: string;
    getLocale() {
        if (this.translate.getActiveLang() == 'en') {
            this.locale = 'en-CA';
        } else if (this.translate.getActiveLang() == 'fr') {
            this.locale = 'fr-CA';
        }
        return this.locale;
    }

    prettyPrintDateTime() {}
    prettyPrintTime() {}

    servicePauseEndTime: string = this.servicePauseEnd.toLocaleTimeString(this.getLocale(), {
        timeStyle: 'short',
    });

    constructor(
        public activeModal: NgbActiveModal,
        public translate: TranslocoService,
    ) {}

    get isCurrentDate() {
        if (this.servicePauseEnd.getDate() == this.currentDate.getDate()) return true;
        else return false;
    }
}

// interval.end
// Deliveries will restart at 4:00pm.
